import React from "react";
import { Link } from "react-router-dom";

const ImageOrGif = () => {
    return (
        <div className="flex justify-center items-center min-h-screen">
            <main className="bg-white p-6 sm:p-8 w-full max-w-7xl">
                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                    Lesson 1: What is the Science of Reading?
                </h3>

                <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                    Phonics
                </h3>

                <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                    <p className="lg:pl-2">What is Phonics?</p>
                    <ul className="list-disc lg:pl-10 pt-2">
                        <li>
                            Phonics is the understanding of the relationships between letters
                            and sounds, and using that knowledge to decode and pronounce
                            words.
                        </li>
                        <li>
                            The ability to manipulate individual and blended sounds in words.
                            Students see and decode each sound within a word and then blend
                            them to say the word.
                        </li>
                        <li>Each time we read a word, we are using phonics.</li>
                    </ul>
                </div>

                {/* Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 justify-center items-center lg:pl-48 lg:pr-48">
                    {/* Card 1 */}
                    <div className="rounded-xl py-16 flex items-center justify-center shadow-md transition-all hover:shadow-lg bg-white">
                        <div className="text-5xl font-bold text-gray-800 tracking-widest">
                            <span className="text-primary mr-24">b</span>i
                            <span className="text-primary ml-24">d</span>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div className="rounded-xl p-2 py-16 flex items-center justify-center shadow-md transition-all hover:shadow-lg bg-white">
                        <div className="text-5xl font-bold text-gray-800 tracking-widest">
                            <span className="text-primary mr-20">sw</span>i
                            <span className="ml-24">m</span>
                        </div>
                    </div>
                </div>

                {/* Next Button */}
                <div className="flex justify-end mt-5">
                    <Link to={"/dashboard/modules/audio-play"}>
                        <button className="px-6 py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-8">
                            ← Previous
                        </button>
                    </Link>

                    <Link to={"/dashboard/modules/audio-card"}>
                        <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                            Continue Lesson →
                        </button>
                    </Link>
                </div>
            </main>
        </div>
    );
};

export default ImageOrGif;
